
export const initializeRazorpayPayment = ({
  paymentData,
  billingDetails = {},
  description = 'Subscription Payment',
  onSuccess,
  onFailure,
  onDismiss
}) => {
  if (!paymentData) {
    console.error('Payment data is required');
    return;
  }

  if (!window.Razorpay) {
    console.error('Razorpay SDK not loaded');
    onFailure?.({ error: { description: 'Razorpay SDK not available' } });
    return;
  }

  const options = {
    key: paymentData.razorpayKeyId,
    amount: paymentData.amount,
    currency: paymentData.currency,
    name: "Prodyt",
    description,
    order_id: paymentData.orderId,
    handler: function (razorpayResponse) {
      onSuccess?.(razorpayResponse);
    },
    modal: {
      ondismiss: function () {
        onDismiss?.();
      },
      escape: true,
      confirm_close: true
    },
    prefill: {
      email: billingDetails?.email || "",
      contact: billingDetails?.phone || ""
    },
    theme: {
      color: "#2650a6"
    }
  };

  try {
    const rzp = new window.Razorpay(options);

    rzp.on("payment.failed", function (failResponse) {
      console.error('Payment failed:', failResponse);
      onFailure?.(failResponse.error);
    });

    rzp.open();
  } catch (error) {
    console.error('Error initializing Razorpay:', error);
    onFailure?.({ description: 'Failed to initialize payment' });
  }
};

export const isRazorpayLoaded = () => {
  return typeof window !== 'undefined' && window.Razorpay;
};

export const loadRazorpaySDK = () => {
  return new Promise((resolve, reject) => {
    if (isRazorpayLoaded()) {
      resolve(window.Razorpay);
      return;
    }

    if (document.querySelector('script[src*="checkout.razorpay.com"]')) {
      const checkLoaded = setInterval(() => {
        if (isRazorpayLoaded()) {
          clearInterval(checkLoaded);
          resolve(window.Razorpay);
        }
      }, 100);

      setTimeout(() => {
        clearInterval(checkLoaded);
        reject(new Error('Razorpay SDK failed to load'));
      }, 10000);
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.defer = true;
    script.onload = () => {
      if (isRazorpayLoaded()) {
        resolve(window.Razorpay);
      } else {
        reject(new Error('Razorpay SDK loaded but not available'));
      }
    };
    script.onerror = () => reject(new Error('Failed to load Razorpay SDK'));
    document.body.appendChild(script);
  });
};